if (!customElements.get('product-card-swatches')) {
  customElements.define(
    'product-card-swatches',
    class ProductCardSwatches extends HTMLElement {
      constructor() {
        super();
        this.onEnter = this.onEnter.bind(this);
        this.onLeave = this.onLeave.bind(this);
      }

      connectedCallback() {
        this.bubbles = Array.from(this.querySelectorAll('.card-swatches__bubble'));
        if (!this.bubbles.length) return;

        const wrapper = this.closest('.card-wrapper') || this.closest('.card');
        this.mediaEl = wrapper ? wrapper.querySelector('.card__media .media') : null;
        this.image = this.mediaEl ? this.mediaEl.querySelector('img') : null;
        if (!this.image) return;

        this.original = {
          src: this.image.getAttribute('src'),
          srcset: this.image.getAttribute('srcset'),
          width: this.image.getAttribute('width'),
          height: this.image.getAttribute('height'),
          alt: this.image.getAttribute('alt'),
        };

        this.bubbles.forEach((bubble) => {
          if (!bubble.dataset.mediaSrc) return;
          bubble.addEventListener('mouseenter', this.onEnter);
          bubble.addEventListener('focus', this.onEnter);
        });

        this.addEventListener('mouseleave', this.onLeave);
        this.addEventListener('focusout', this.onLeave);
      }

      disconnectedCallback() {
        this.removeEventListener('mouseleave', this.onLeave);
        this.removeEventListener('focusout', this.onLeave);
      }

      onEnter(event) {
        const bubble = event.currentTarget;
        const { mediaSrc, mediaSrcset, mediaWidth, mediaHeight, mediaAlt } = bubble.dataset;
        if (!mediaSrc || !this.image) return;

        if (mediaSrcset) this.image.setAttribute('srcset', mediaSrcset.trim());
        this.image.setAttribute('src', mediaSrc);
        if (mediaWidth) this.image.setAttribute('width', mediaWidth);
        if (mediaHeight) this.image.setAttribute('height', mediaHeight);
        if (typeof mediaAlt === 'string') this.image.setAttribute('alt', mediaAlt);

        if (this.mediaEl) this.mediaEl.classList.add('card-swatches-active');
      }

      onLeave(event) {
        // For focusout, ignore moves between bubbles inside this element.
        if (event.relatedTarget && this.contains(event.relatedTarget)) return;
        this.restore();
      }

      restore() {
        if (!this.image || !this.original) return;

        if (this.original.srcset != null) {
          this.image.setAttribute('srcset', this.original.srcset);
        } else {
          this.image.removeAttribute('srcset');
        }
        if (this.original.src != null) this.image.setAttribute('src', this.original.src);
        if (this.original.width != null) this.image.setAttribute('width', this.original.width);
        if (this.original.height != null) this.image.setAttribute('height', this.original.height);
        if (this.original.alt != null) this.image.setAttribute('alt', this.original.alt);

        if (this.mediaEl) this.mediaEl.classList.remove('card-swatches-active');
      }
    }
  );
}
